import { render } from "./StudentHome.vue?vue&type=template&id=e22e6d64"
import script from "./StudentHome.vue?vue&type=script&lang=js"
export * from "./StudentHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__